import { useEffect, useState } from "react";
import { db } from "./firebase";
import { collection, getDocs } from "firebase/firestore";
import { Link } from "react-router-dom";
import PageLayout from "./components/PageLayout";

function Spotlight() {
  const [popularParts, setPopularParts] = useState([]);
  const [popularBrands, setPopularBrands] = useState([]);
  const [popularMakes, setPopularMakes] = useState([]);

  useEffect(() => {
    const loadSpotlightData = async () => {
      const snapshot = await getDocs(collection(db, "profiles"));

      const partCounts = {};
      const brandCounts = {};
      const makeCounts = {};

      snapshot.forEach((doc) => {
        const profile = doc.data();

        profile.garageCars?.forEach((car) => {
          if (car.make) {
            makeCounts[car.make] = (makeCounts[car.make] || 0) + 1;
          }

          car.mods?.forEach((mod) => {
            if (mod.partName) {
              partCounts[mod.partName] =
                (partCounts[mod.partName] || 0) + 1;
            }

            if (mod.brand) {
              brandCounts[mod.brand] =
                (brandCounts[mod.brand] || 0) + 1;
            }
          });
        });
      });

      setPopularParts(
        Object.entries(partCounts)
          .sort((a, b) => b[1] - a[1])
          .slice(0, 10)
      );

      setPopularBrands(
        Object.entries(brandCounts)
          .sort((a, b) => b[1] - a[1])
          .slice(0, 10)
      );

      setPopularMakes(
        Object.entries(makeCounts)
          .sort((a, b) => b[1] - a[1])
          .slice(0, 10)
      );
    };

    loadSpotlightData();
  }, []);

  return (
    <PageLayout
      title="Spotlight"
      subtitle="See what parts, brands, and platforms are trending across MyBuildID."
      maxWidth="600px"
    >
      <RankingCard
        title="🔥 Popular Parts"
        rankings={popularParts}
      />

      <RankingCard
        title="🏭 Popular Brands"
        rankings={popularBrands}
      />

      <RankingCard
        title="🚗 Popular Makes"
        rankings={popularMakes}
      />
    </PageLayout>
  );
}

function RankingCard({ title, rankings }) {
  return (
    <div style={cardStyle}>
      <h2>{title}</h2>

      {rankings.length > 0 ? (
        rankings.map(([name, count], index) => (
          <div key={name} style={rowStyle}>
            <Link
              to={`/discover?search=${encodeURIComponent(name)}`}
              style={rankingLinkStyle}
            >
              #{index + 1} {name}
            </Link>

            <span>{count}</span>
          </div>
        ))
      ) : (
        <p>No data yet.</p>
      )}
    </div>
  );
}

const cardStyle = {
  backgroundColor: "#181818",
  border: "1px solid #242424",
  borderRadius: "18px",
  padding: "20px",
  marginBottom: "18px",
};

const rowStyle = {
  display: "flex",
  justifyContent: "space-between",
  borderBottom: "1px solid #2a2a2a",
  padding: "12px 0",
};

const rankingLinkStyle = {
  color: "white",
  textDecoration: "none",
  fontWeight: "bold",
};

export default Spotlight;